export const getSupportedConstraints = () => {
  if (typeof navigator === "undefined" || !navigator.mediaDevices?.getSupportedConstraints) {
    return {};
  }

  return navigator.mediaDevices.getSupportedConstraints();
};
